import { render, staticRenderFns } from "./AnnualReturnReport.vue?vue&type=template&id=2d0133fe&scoped=true&"
import script from "./AnnualReturnReport.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnReport.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnReport.vue?vue&type=style&index=0&id=2d0133fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0133fe",
  null
  
)

export default component.exports